import { render } from "./Campaign.vue?vue&type=template&id=09be28ae&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=09be28ae&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09be28ae"]])

export default __exports__